var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-table',{attrs:{"url":_vm.url,"title":"لیست درگاه ها","detailUrl":_vm.detailUrl,"viewUrl":_vm.viewUrl,"fields":_vm.fields,"params":_vm.params,"tabTable":_vm.tabTable,"excelroute":'asdasd'}})
}
var staticRenderFns = []

export { render, staticRenderFns }